import React from 'react';

/**
 * Format aesthetic text while preserving JSX/HTML tags
 * This function specially handles 'ＡＥＳＴＨＥＴＩＣＳ' to ensure it stays on one line
 * without breaking surrounding JSX tags
 *
 * @param {string} text - The text to format
 * @returns {React.ReactNode} - The formatted text as React elements
 */
const formatAestheticText = (text) => {
    if (typeof text !== 'string') return text;

    // Regular expressions for the two formats
    const withSpacesRegex = /Ａ\s+Ｅ\s+Ｓ\s+Ｔ\s+Ｈ\s+Ｅ\s+Ｔ\s+Ｉ\s+Ｃ\s+Ｓ/g;
    const withoutSpacesRegex = /ＡＥＳＴＨＥＴＩＣＳ/g;

    // Replace the aesthetic text with a special marker we can split on
    // This marker is unlikely to appear in real text
    const MARKER = ':::AESTHETIC_TEXT_MARKER:::';

    // First replace the version with spaces
    let processedText = text.replace(withSpacesRegex, MARKER);

    // Then replace the version without spaces
    processedText = processedText.replace(withoutSpacesRegex, MARKER);

    // If no replacements were made, return the original text
    if (!processedText.includes(MARKER)) {
        return text;
    }

    // Split the text by our marker
    const parts = processedText.split(MARKER);

    // Create the result with React elements
    const result = [];

    for (let i = 0; i < parts.length; i++) {
        // Add the regular part
        if (parts[i]) {
            result.push(parts[i]);
        }

        // Add the aesthetic part except after the last regular part
        if (i < parts.length - 1) {
            const aestheticText = text.includes('Ａ Ｅ Ｓ Ｔ Ｈ Ｅ Ｔ Ｉ Ｃ Ｓ')
                ? 'Ａ Ｅ Ｓ Ｔ Ｈ Ｅ Ｔ Ｉ Ｃ Ｓ'
                : 'ＡＥＳＴＨＥＴＩＣＳ';

            result.push(
                <span key={`aesthetic-${i}`} className="aesthetic-word">
                    {aestheticText}
                </span>
            );
        }
    }

    return <>{result}</>;
};

export default formatAestheticText;